import Label from './Label';

export * from './Label';
export default Label;
